import { Box, Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Container, Divider, Message, Overlay, Title } from "./style";
import { Button } from "../Button";

interface LearningActivityBlockOverlayProps {
  onClose: () => void,
  previousRoute: string
}

const LearningActivityBlockOverlay = ({ onClose, previousRoute }: LearningActivityBlockOverlayProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Fade in>
      <Overlay alignSelf={ "center" }>
        <Container gap={ "30px" } theme={ theme }>
          <Title theme={ theme }>{ t("scorm_session_timeout_title") }</Title>
          <Divider theme={ theme }/>
          <Message theme={ theme }>{ t("scorm_session_timeout_message") }</Message>
          <Divider theme={ theme }/>
          <Box>
            <Button onClick={ () =>  {
              navigate(previousRoute);
              onClose();
            } } variant={ "contained" }>{ t("save_close") }</Button>
          </Box>
        </Container>
      </Overlay>
    </Fade>
  );
};

export default LearningActivityBlockOverlay;
